import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Navigation } from 'src/app/enums/navigation.enum';
import { Entry } from 'src/app/models/entry';
import { EntryService } from 'src/app/services/entry.service';

@Component({
    selector: 'app-entry-create',
    templateUrl: './entry-create.component.html',
    styleUrls: ['./entry-create.component.scss'],
    standalone: false
})
export class EntryCreateComponent implements OnInit, OnChanges {

  @Input() redirectOnSuccess = true;
  @Input() eventId;
  @Input() referees;
  modalId = 'entry-create-modal';
  entry: Entry;
  private _entry: Entry = new Entry();
  public auth = inject(Auth);
  constructor(
    private _router: Router,
    private _entryService: EntryService,
    private _modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this._entry.eventId = this.eventId;
    this._entry.referees = this.referees;
    this.entry = Object.assign({}, this._entry);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes['referees']){
      this._entry.referees = this.referees;
      this.entry = Object.assign({}, this._entry);
    }
  }
  async add() {
    const id = await this._entryService.add(this.entry);
    this._modalService.dismissAll();
    if(this.redirectOnSuccess){
      this._router.navigate([Navigation.EntryDetail, id]);
    }
  }
  open(content) {
    this._modalService.open(content, {ariaLabelledBy: this.modalId, centered: true}).result.then((result) => {
      this.entry = Object.assign({}, this._entry);
    }, (reason) => {
      this.entry = Object.assign({}, this._entry);
    });
  }
}
